import React from 'react';
import { useFormContext } from 'react-hook-form';
import { InputAdornment } from '@infoods/lifebase-ui';
import { ChallengeFormValues } from '../../../../../../interfaces/ChallengeFormValues';
import { STEP_FORM_ID } from '../../GuidedChallengeCreation.settings';
import { LbNumericFormatInput } from '../../../../../../../shared/components/form-components';

type Props = {
  onNext: () => void;
};

const PriceStep = ({ onNext }: Props) => {
  const { control, trigger } = useFormContext<ChallengeFormValues>();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const isValid = await trigger('about.price');

    if (isValid) {
      onNext();
    }
  };

  return (
    <form id={STEP_FORM_ID} onSubmit={onSubmit} noValidate>
      <LbNumericFormatInput
        size="small"
        variant="standard"
        label="Price"
        control={control}
        name="about.price"
        prefix="$"
        decimalScale={2}
        fixedDecimalScale
        rules={{
          required: 'Price is required',
          min: { value: 1, message: 'Price must be at least $1.00' },
        }}
        InputProps={{
          endAdornment: <InputAdornment position="end">per customer</InputAdornment>,
        }}
      />
    </form>
  );
};

export { PriceStep };
